'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFocusOn = require('react-focus-on');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactTransitionGroupCSSTransitionGroup = require('react-transition-group/CSSTransitionGroup');

var _reactTransitionGroupCSSTransitionGroup2 = _interopRequireDefault(_reactTransitionGroupCSSTransitionGroup);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var Modal = (function (_React$Component) {
	_inherits(Modal, _React$Component);

	function Modal() {
		_classCallCheck(this, Modal);

		_get(Object.getPrototypeOf(Modal.prototype), 'constructor', this).apply(this, arguments);
	}

	_createClass(Modal, [{
		key: 'handleClose',
		value: function handleClose() {
			this.props.onCancel();
		}
	}, {
		key: 'onContentClick',
		value: function onContentClick(event) {
			// Parent div 'Modal' closes the modal on click event.
			// Prevent click event propagating to the Parent div 'Modal'.
			if (event.stopPropagation) {
				event.stopPropagation();
			} else {
				event.returnValue = false; //For IE
			}
		}
	}, {
		key: 'renderDialog',
		value: function renderDialog() {
			var _this = this;

			if (!this.props.isOpen) return false;
			var close = this.props.showCloseButton ? _react2['default'].createElement('button', {
				type: 'button',
				onClick: this.handleClose.bind(this),
				className: 'Modal__close',
				ref: function (ref) {
					_this.closeButton = ref;
				}
			}) : null;
			var back = this.props.back ? _react2['default'].createElement(
				'div',
				{ className: 'Modal__back' },
				this.props.back
			) : null;
			return _react2['default'].createElement(
				'div',
				{ className: 'Modal-' + this.props.type, id: 'modalDialog' },
				_react2['default'].createElement(
					'div',
					{
						ref: function (ref) {
							_this.modalElement = ref;
						},
						style: this.props.width && !isNaN(this.props.width) ? { width: this.props.width + 20 } : null,
						tabIndex: '0',
						className: (0, _classnames2['default'])('Modal-content-' + this.props.type, this.props.width && isNaN(this.props.width) ? 'Modal-content--' + this.props.type + '--' + this.props.width : null),
						onClick: this.onContentClick.bind(this)
					},
					close,
					back,
					this.props.children
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var className = (0, _classnames2['default'])('Modal', {
				'is-open': this.props.isOpen,
				'is-opaque': this.props.opaque
			}, this.props.className);
			var props = (0, _blacklist2['default'])(this.props, 'backdropClosesModal', 'className', 'isOpen', 'onCancel', 'opaque', 'showCloseButton', 'type');

			var contents = _react2['default'].createElement(
				'div',
				_extends({}, props, { 'data-modal': 'true', className: className }),
				_react2['default'].createElement(
					_reactFocusOn.FocusOn,
					{ enabled: this.props.isOpen,
						onEscapeKey: this.handleClose.bind(this),
						onClickOutside: this.props.backdropClosesModal ? this.handleClose.bind(this) : function () {} },
					_react2['default'].createElement(
						_reactTransitionGroupCSSTransitionGroup2['default'],
						{
							transitionName: 'Modal-' + this.props.type,
							component: 'div',
							transitionEnterTimeout: 350,
							transitionLeaveTimeout: 350 },
						this.renderDialog()
					)
				)
			);

			// Delay createPortal until component is mounted to fix server side rendering
			return typeof document !== 'undefined' && _reactDom2['default'].createPortal(contents, document.body);
		}
	}]);

	return Modal;
})(_react2['default'].Component);

Modal.propTypes = {
	back: _propTypes2['default'].node,
	backdropClosesModal: _propTypes2['default'].bool,
	className: _propTypes2['default'].string,
	isOpen: _propTypes2['default'].bool,
	onCancel: _propTypes2['default'].func,
	opaque: _propTypes2['default'].bool,
	showCloseButton: _propTypes2['default'].bool,
	type: _propTypes2['default'].oneOf(['dialog', 'default']),
	width: _propTypes2['default'].oneOfType([_propTypes2['default'].oneOf(['small', 'medium', 'large']), _propTypes2['default'].number])
};

Modal.defaultProps = {
	width: 'medium',
	showCloseButton: true,
	backdropClosesModal: true,
	type: 'default',
	opaque: false,
	isOpen: false
};

module.exports = Modal;
// expose the children to the top level export
module.exports.Body = require('./ModalBody');
module.exports.Footer = require('./ModalFooter');
module.exports.Header = require('./ModalHeader');